import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const salesOrderListTodo = createAsyncThunk('salesOrderList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `customer-sales-orders`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'deliveryDate': data?.deliveryDate && moment(data?.deliveryDate).format('YYYY-MM-DD'),
                'customerId': data?.customerId,
                'salesOrderType': 'cs',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const salesOrderListSlice = createSlice({
    name: 'salesOrderList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(salesOrderListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(salesOrderListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default salesOrderListSlice.reducer; 